import React from "react";
import { Link } from "react-router-dom";

/**
 * Terms of Service — placeholder/template content. Replace with vendor-vetted
 * legal copy before going live globally. Anchor links: /terms#sectionId.
 */
export default function Terms() {
  return (
    <div className="min-h-screen bg-[#F4F2EC] text-black">
      <div className="max-w-3xl mx-auto px-5 py-10">
        <Link to="/" className="font-mono text-xs uppercase tracking-widest text-[#C2410C]">← Vendor Vault</Link>
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#4A4A4A] mt-6">Legal</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black uppercase mt-1">Terms of Service</h1>
        <div className="font-mono text-xs text-[#4A4A4A] mt-2">Effective: February 2026</div>

        <div className="prose prose-sm max-w-none mt-8 font-mono text-sm leading-relaxed space-y-5">
          <p>By creating an account or using Vendor Vault ("the Service"), you agree to these Terms.
            If you do not agree, please don't use the Service.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">1. Accounts</h2>
          <p>You are responsible for keeping your password secure. You must provide a real email address
            and verify it. We reserve the right to suspend or delete accounts that violate these Terms
            or appear fraudulent.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">2. Subscriptions & Billing</h2>
          <p>Paid plans (Pro, Business) are billed monthly via Stripe. You may cancel at any time from
            <code> /billing</code>; access continues until the end of the paid period. We do not issue
            partial refunds for unused time, but contact <a href="mailto:support@vendorvaultonline.com">support@vendorvaultonline.com</a> if you have an issue and we'll try to help.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">3. Your data</h2>
          <p>You own your products, sales, and customer records. We process them solely to provide the
            Service. We will not sell your data. You can export your data at any time or request
            deletion from <code>/billing</code>.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">4. Third-party services</h2>
          <p>Connecting Square or Shopify means the Service uses their APIs on your behalf. We never see
            or store your customer card numbers — those flow through Square / Stripe directly. Their
            terms apply on top of ours.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">5. Acceptable use</h2>
          <p>Don't use the Service to sell illegal goods, abuse our infrastructure (scraping, denial of
            service, etc.), or harass other users.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">6. Limits of liability</h2>
          <p>The Service is provided "as is". To the maximum extent allowed by law, Vendor Vault is not
            liable for indirect damages such as lost profits or lost data. Our total liability in any
            12-month period is capped at the amount you paid us in that period.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">7. Changes</h2>
          <p>We may update these Terms. We'll email you about material changes; continued use means
            acceptance.</p>

          <h2 className="font-heading text-lg font-black uppercase mt-6">8. Contact</h2>
          <p>Questions? <a href="mailto:support@vendorvaultonline.com">support@vendorvaultonline.com</a></p>
        </div>

        <div className="mt-12 pt-6 border-t-2 border-black flex flex-wrap gap-4 font-mono text-xs">
          <Link to="/privacy" className="underline">Privacy Policy</Link>
          <Link to="/" className="underline">Home</Link>
        </div>
      </div>
    </div>
  );
}
